import CalendarIcon from '@mui/icons-material/CalendarToday';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { DATE_TIME_DAY_TITLE_FORMAT } from '../../helpers/time';
import { stripAppointmentTypeFromAppointmentName } from '../../lib/format';
import { Provider } from '../../lib/scheduling/types';
import VisitWarning from './components/VisitWarning';

type Props = {
  conflictingAppointment: {
    appointmentType: string;
    provider: Provider;
    startAt: string;
  };
  onClose: () => void;
};

const ScheduleConflictDialog: FC<Props> = ({ conflictingAppointment, onClose }) => {
  const { appointmentType, provider, startAt } = conflictingAppointment;

  return (
    <Dialog onClose={onClose} open={true}>
      <DialogTitle>
        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
          <Typography variant='h3'>Schedule Conflict</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon fontSize='small' />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Stack style={{ gap: 16 }}>
          <Typography variant='h5'>
            You already have a nutrition or exercise appointment scheduled this week:
          </Typography>

          <Stack style={{ gap: 4 }}>
            <Typography variant='h5'>
              {stripAppointmentTypeFromAppointmentName(appointmentType)} with:
            </Typography>

            <Box display={'flex'} alignItems={'center'} gap={1}>
              <PersonIcon fontSize='small' />
              <Typography variant='h5'>
                {provider.firstName} {provider.lastName}
              </Typography>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={1}>
              <CalendarIcon fontSize='small' />
              <Typography variant='h5'>
                {DateTime.fromISO(startAt).toFormat(DATE_TIME_DAY_TITLE_FORMAT)}
              </Typography>
            </Box>
          </Stack>

          <Typography variant='h5'>
            To book this class, cancel your other appointment first.
          </Typography>

          <VisitWarning />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleConflictDialog;
